// extracted by mini-css-extract-plugin
module.exports = {"image-fullscreen__wrapper":"styles_image-fullscreen__wrapper__1Katl"};